<template>
  <div class="toast-position">
    <div class="toast-container">
      <transition-group name="toastDown">
        <div class="toast" v-for="(msg, index) in messages" :key="index + 0">
          <div class="option">
            <i class="fa fa-times" aria-hidden="true" @click="e => deleteToastAction(index)"></i>
          </div>
          <div class="line" :class="[msg.type]"></div>
          <div class="content" v-html="msg.content"></div>
        </div>
      </transition-group>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  computed: mapGetters([
    'messages'
  ]),
  methods: {
    ...mapActions([
      'deleteToastAction'
    ])
  }
}
</script>



// WEBPACK FOOTER //
// src/components/tool/toast.vue